import React, { useState, useEffect, useCallback } from 'react';
import { Box, Select } from 'grommet';
import { ThemeContext } from 'grommet';
import { STATUS_OPTIONS } from 'pto/constants';

const Filter = ({ status, setFilterStatus }) => {
  return (
    <Box fill align="start" justify="start">
      <ThemeContext.Extend
        value={{
          global: {
            hover: {
              background: {
                color: undefined,
              },
            },
          },
          select: {
            hover: undefined,
            options: {
              container: {
                extend: `
                    /* Reset any inherited styles first */
                    button[role="option"] {
                      background-color: white;
                      color: inherit;
                      transition: all 0.2s ease;
                    }
                    
                    /* Non-selected hover state */
                    button[role="option"]:hover:not([aria-selected="true"]) {
                      background-color: rgba(221, 221, 221, 0.4) !important;
                    }
                    
                    /* Selected state */
                    button[role="option"][aria-selected="true"] {
                      background-color: rgb(0, 115, 157) !important;
                      color: white !important;
                    }
                    
                    /* Selected hover state - keep it blue */
                    button[role="option"][aria-selected="true"]:hover {
                      background-color: rgb(0, 115, 157) !important;
                      color: white !important;
                    }
                  `,
              },
            },
          },
        }}
      >
        <Select
          options={STATUS_OPTIONS}
          value={status}
          valueKey={{ key: 'id', reduce: true }}
          labelKey="name"
          onChange={({ value: nextValue }) => setFilterStatus(nextValue)}
        />
      </ThemeContext.Extend>
    </Box>
  );
};

export default Filter;
